import {Injectable, signal} from "@angular/core"
import {UnassignedJobData} from "@template-editor/helpers/template-jobs"
import {Subject} from "rxjs"

@Injectable()
export class TemplateJobManagerService {
    readonly $unassignedJobs = signal<UnassignedJobData[]>([])
    readonly $selectedUnassignedJob = signal<UnassignedJobData | undefined>(undefined)
    // Emits after jobs were discarded elsewhere, so a view showing one of them reloads.
    readonly jobsDiscarded$ = new Subject<void>()
}
